"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FoamParticle = exports.textureLoader = void 0;
const three_6 = require("three");
//
exports.textureLoader = new three_6.TextureLoader();
const particleTexture = exports.textureLoader.load('/resources/textures/particle.png');
class FoamParticle extends three_6.ShaderMaterial {
    constructor() {
        super();
        this.transparent = true;
        this.vertexShader = `
        attribute float foamSize;

        uniform float uTime;

        void main () {

            vec4 mvPosition = modelViewMatrix * vec4( vec3( position.x - 0.057 + uTime / 10.0, position.y - 0.05 + uTime / 10.0, position.z + uTime / 10.0 ), 1.0 );

            gl_PointSize = foamSize * 0.0068  * ( 300.0 / -mvPosition.z );

            gl_Position = projectionMatrix * mvPosition;

        }`,
            this.fragmentShader = `
        uniform sampler2D uPointTexture;
        uniform vec3 uColor;

        void main () {

            gl_FragColor = vec4( uColor, 1.0 ) * texture2D( uPointTexture, gl_PointCoord );
            if ( gl_FragColor.a < 0.3 ) discard;

        }`,
            this.uniforms = {
                uPointTexture: { value: particleTexture },
                uColor: { value: new three_6.Color(0xc5e0fc) },
                uTime: { value: 0 }
            };
    }
}
exports.FoamParticle = FoamParticle;
;
